<template>
  <q-dialog v-model="remove" persistent transition-show="scale" transition-hide="scale">
    <q-card style="width:320px">
      <div class="alert-box">
        <div class="alert-title">ALERT!!</div>
        <div class="alert-content">
          <div class="alert-text">
            Are you sure to delete
            <span class="bold">{{name}}</span> manual ?
          </div>
          <div class="alert-actions">
            <q-btn flat @click="remove=false">CANCEL</q-btn>
            <q-btn flat :loading="loading" :disable="loading" label="OK" @click="del">
              <template v-slot:loading>
                <q-spinner-facebook />
              </template>
            </q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>
<script>
import axios from '../axios'
export default {
  data() {
    return {
      name: "",
      loading: false,
    };
  },
  methods: {
    async del() {
      try {
        this.loading = true;
        // server fire
        await axios.delete(`vehicle-tag/${this.selectedTag.id}`);
        this.loading = false;
        this.remove = false;
        this.$store.commit("tag/REMOVE_TAG", this.selectedTag.id);
        this.$store.commit("vehicle/REMOVE_TAG_EXISTING_VEHICLE", this.selectedTag.id);
        this.$store.commit("profit/REMOVE_TAG_EXISTING_VEHICLE", this.selectedTag.id);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    remove: {
      get() {
        return this.$store.state.tag.remove;
      },
      set(val) {
        this.$store.commit("tag/SET_REMOVE", val);
      },
    },
    selectedTag() {
      return this.$store.state.tag.selectedTag;
    },
  },
  watch: {
    remove(n, o) {
      n ? (this.name = this.selectedTag.name) : "";
    },
  },
};
</script>
